// Simple event bus plugin for Vue 3
// Replaces the deprecated $root.$on/$off/$emit pattern

class EventBus {
  constructor() {
    this.events = {};
  }

  on(event, callback) {
    if (!this.events[event]) {
      this.events[event] = [];
    }
    this.events[event].push(callback);
  }

  off(event, callback) {
    if (!this.events[event]) return;

    if (callback) {
      this.events[event] = this.events[event].filter((cb) => cb !== callback);
    } else {
      delete this.events[event];
    }
  }

  emit(event, ...args) {
    if (!this.events[event]) return;

    this.events[event].forEach((callback) => {
      callback(...args);
    });
  }
}

export default {
  install(app) {
    const eventBus = new EventBus();

    app.config.globalProperties.$eventBus = eventBus;
    app.provide('eventBus', eventBus);
  }
};
